module.exports = __webpack_public_path__ + "fonts/AvertaStd-Extrathin.eot";